// extracted by mini-css-extract-plugin
export default {"container":"TermsOfService_container__-pImy","title":"TermsOfService_title__Fs98X","content":"TermsOfService_content__SeoRK"};